import { render } from "./shenyang.vue?vue&type=template&id=6a8ff61e&scoped=true"
import script from "./shenyang.vue?vue&type=script&lang=js"
export * from "./shenyang.vue?vue&type=script&lang=js"

import "./shenyang.vue?vue&type=style&index=0&id=6a8ff61e&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8ff61e"]])

export default __exports__